<template>
  <div class="c-kdo-autofill">
    <div class="kdo-hint intro">
      Эти макросы система подставляет в документ сама — создавать их не нужно, достаточно написать в Word, например,
      <span class="kdo-macro">${employeeFullName}</span>. Макросы сотрудника работают, только если к документу прикреплён
      сотрудник (в шаблоне есть поле «Сотрудник»).
    </div>

    <div class="kdo-toolbar">
      <input v-model="search" class="kdo-search" type="text" placeholder="Поиск по макросу или описанию">
    </div>

    <div class="kdo-card">
      <table>
        <thead>
          <tr>
            <th>Макрос</th>
            <th>Что подставляется</th>
            <th>Источник</th>
            <th>Условие</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in filtered" :key="item.metaKey">
            <td><span class="kdo-macro">{{ item.macro }}</span></td>
            <td>{{ item.title }}</td>
            <td>{{ item.sourceTitle }}</td>
            <td>
              <span class="kdo-badge" :class="item.requires ? 'warn' : 'ok'">{{ item.note }}</span>
            </td>
          </tr>
          <tr v-if="!filtered.length">
            <td colspan="4" class="empty">Ничего не найдено</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CKdoAutofillReference',
  data() {
    return {
      items: [],
      search: '',
    }
  },
  computed: {
    filtered() {
      const query = this.search.trim().toLowerCase()
      if (!query) return this.items
      return this.items.filter((item) => item.metaKey.toLowerCase().includes(query) || item.title.toLowerCase().includes(query))
    },
  },
  created() {
    $api.kdo.dictionaries().then((response) => {
      this.items = response.data.content.autofill || []
    })
  },
}
</script>

<style lang="scss" scoped>
@import './kdo.scss';

.intro {
  margin: 12px 0;
  font-size: 14px;
  line-height: 1.5;
}
</style>
